import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

import * as S from './styles';
import { Band, Inner } from '../ui/Section';
import { Cta } from '../ui/PriceList';
import Reveal from '../ui/Reveal';
import { useWhatsappLink } from '../Splash';

const REVIEWS_URL =
  'https://www.google.com/search?sca_esv=c4803f513892b5ac&rlz=1CDGOYI_enBR669BR669&hl=pt&q=avalia%C3%A7%C3%B5es+sobre+spedine+studio+s%C3%A3o+paulo&uds=ADvngMiDNapinLEnB0aM2oAlohp7_LKRG4_Uu5JdLWhHlEL5XmGCoIboDPrSXPH3tcDLUdvSsqcE9g-wu_mAhxPlgtK5rjsxkV1JV9MMYPwim7EaS1KZc2Svn_QSF0vXwYgSPBEYNCj8kPbJYFqRDhfuodxJOvWm7Q7HtVr0ul6nrz98jUekdR0-DW414WEr0EbjXjeI243nLXc7bPOjJ4MIi5r5uQl0rGNTalTUrleDPvm7yD7KR0K8Oe3fmCAE8x342VpPHuEDNZfItP80WNfqhdgtzqYCzq2YBTYQ9mYYf6CmzSE_LFDTYxwQ4VcH2vgL6FNBMxIaExLlbmf9rXJaPw27GaYbCEu5wppGV0Jp59YOQhg-bozgunOCQtCGZ2bNlvcp7W1bCdH8BM6GBP6-OYYYpttZSdN6GBWYtEHuW2fpxIfroLDdbuyQ9zu4vwdBGZ0iGZUEsPyc0exrt_9t9ZsuEQi0GrXOHQ5Q1Z915vvSK6khtcBlgLA_ffF1S5tREFIvrm4h&si=ACC90nwjPmqJHrCEt6ewASzksVFQDX8zco_7MgBaIawvaF4-7lh_Lvv56PHaEw1HpQtZ5FX4e21COA-3614Y6VN7jxRkwN9KQGwDOYPEXdv9y5oG--GdI9MR_3VMYsZ0UBgQD-p38Wf7gnVmNL4QcUWIuIwAsyO9U4hsdhAtnBZjSS6i_usuAhc%3D&sa=X&ved=2ahUKEwibjZOLt56JAxU1K7kGHVDMKS0Qk8gLegQIHBAB&ictx=1&biw=393&bih=665&dpr=3#ebo=1';

const MAP_SRC =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.9994984491527!2d-46.73047442429369!3d-23.496527559214215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x41881a65470c3363%3A0x4331a08d64302ac9!2sSpedine%20Studio!5e0!3m2!1spt-BR!2sbr!4v1729477591958!5m2!1spt-BR!2sbr';

function Rodape() {
  const whatsapp = useWhatsappLink();

  return (
    <Band as="footer" id="estudio" $tone="dark">
      <Inner>
        <S.Layout>
          <Reveal>
            <S.Details>
              <p className="eyebrow">
                <FormattedMessage id="footer.eyebrow" />
              </p>
              <h2>
                Spedine
                <span>Studio</span>
              </h2>

              <dl>
                <dt>
                  <FormattedMessage id="studio.addressLabel" />
                </dt>
                <dd>
                  <FormattedMessage id="studio.address" />
                </dd>
              </dl>

              <S.Links>
                <Cta href={whatsapp} target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faWhatsapp} />
                  <FormattedMessage id="hero.book" />
                </Cta>
                <Cta
                  className="ghost"
                  href="https://www.instagram.com/spedinestudio/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                  <FormattedMessage id="studio.instagram" />
                </Cta>
                <Cta className="ghost" href={REVIEWS_URL} target="_blank" rel="noreferrer">
                  <FormattedMessage id="footer.reviews" />
                </Cta>
              </S.Links>
            </S.Details>
          </Reveal>

          <Reveal delay={120}>
            <S.Map>
              <iframe
                title="Spedine Studio no mapa"
                src={MAP_SRC}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </S.Map>
          </Reveal>
        </S.Layout>

        <S.Colophon>
          <span>© {new Date().getFullYear()} Spedine Studio</span>
          <span>Chácara Inglesa · São Paulo</span>
        </S.Colophon>
      </Inner>
    </Band>
  );
}

export default Rodape;
